import { voices } from '@/mocks/voices';
import SectionHeading from '@/components/base/SectionHeading';
import { themeSoft } from '@/utils/theme';
import type { ThemeKey } from '@/types/content';

export default function VoicesSection() {
  return (
    <section className="bg-background-50 border-b border-background-200">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <SectionHeading eyebrow="READERS" title="读者怎么说" desc="他们的评价，也是我们继续做核实这件事的理由。" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {voices.map((v) => {
            const theme = v.theme as ThemeKey;
            return (
              <figure key={v.name} className="p-6 rounded-lg border border-background-200 bg-background-100 flex flex-col">
                <i className="ri-double-quotes-l text-2xl text-primary-400 mb-3"></i>
                <blockquote className="text-sm md:text-base text-foreground-700 leading-relaxed flex-1">{v.text}</blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className={`w-10 h-10 rounded-full flex items-center justify-center font-heading font-bold ${themeSoft[theme]}`}>
                    {v.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-950">{v.name}</span>
                    <span className="block text-xs text-foreground-500">{v.title}</span>
                  </span>
                </figcaption>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}